<template lang="pug">
  component(:is="layout")
</template>

<script>
import { mapGetters } from 'vuex';

import DefaultLayout from '@/components/Layout/Layouts/DefaultLayout.vue';
import HomepageLayout from '@/components/Layout/Layouts/HomepageLayout.vue';
import EmptyLayout from '@/components/Layout/Layouts/EmptyLayout.vue';

export default {
  components: {
    DefaultLayout,
    HomepageLayout,
    EmptyLayout,
  },
  data() {
    return {
      layout: false,
    };
  },
  computed: {
    ...mapGetters({
      darkTheme: 'darkTheme',
    }),
  },
  watch: {
    $route: {
      handler() {
        this.layout = this.$route.meta.layout || 'default-layout';
        this.$loader.stop();
      },
    },
  },
  created() {
    // window.addEventListener('storage', this.watchStorage);
  },
  mounted() {
    if (this.darkTheme) {
      this.$vuetify.theme.dark = true;
    }
  },
  beforeDestroy() {
    // window.removeEventListener('storage', this.watchStorage);
  },
  methods: {
    watchStorage(e) {
      if (e.key === 'vuex-sdo') { // обновление vuex хранилища в других вкладках при изменении в основной
        const { $store, $router, $user } = this;
        const data = JSON.parse(e.newValue) ?? {};
        $store.dispatch('SET_STATE', data);
        if ($user.isAuthenticated) {
          $router.push({ name: 'Desktop' });
        } else $router.push({ name: 'Home' });
      }
    },
  },
};
</script>

<style lang="scss">
  @import "~@/styles/app";
  @import '~vuetify/src/styles/settings/_variables';
</style>
